
import { Button } from "react-bootstrap";
import styled from "styled-components";

export const ButtonRefresh = styled(Button)`
    position: absolute;
    top: 0px;
    right: 10px;
    z-index: 1;
    padding: 8px 16px!important;
    color: #0d6efd!important;
    border: 1px solid transparent;
    border-radius: 10px;
    text-decoration: none!important;
    font-size: 1rem!important;

    display: flex;
    align-items: center;
    gap: 6px;

    &:hover{
        border-top: 1px solid;
        border-color: #e9ecef;
        border-top-right-radius: 8px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    svg {
        width: 16px;
        height: 16px;
    }
`